import { defineMessages } from 'react-intl';

/* eslint-disable max-len */

export default defineMessages({
  headerCompanys: {
    id: 'reviews.header.headerCompanys',
    description: "Company's", // eslint-disable-line
    defaultMessage: 'Yrityksen',
  },
  headerCompanyReviews: {
    id: 'reviews.header.headerCompanyReviews',
    description: 'Reviews',
    defaultMessage: 'saamat arvioinnit',
  },
  headerTextUser: {
    id: 'reviews.header.headerTextUser',
    description: 'Header line text for user reviews',
    defaultMessage: `<p>Käyttäjän
                       <strong>
                         {textLabel}
                       </strong>
                       antamat arvioinnit
                     </p>`,
  },
});
